// eslint-disable-next-line import/no-unresolved
module.exports = require('./dist/index.js').default;



//////////////////
// WEBPACK FOOTER
// ./~/react-dates/~/react-with-styles-interface-css/index.js
// module id = 2692
// module chunks = 0